<div>
    <mat-dialog-content>
        <div class="header">
            <div style="display: flex; justify-content: space-between; gap: 16px;">
                <img src="/assets/icons/Badgegreen-check.svg" alt="Badgegreen-check"/>
                <p style="font-size: 18px; font-weight: 700; margin: 10px 0px;"><span *ngIf="is_active">Deactivated</span><span *ngIf="!is_active">Activated</span> Successfully</p>
            </div>
            
           
            
        </div>
        <p style="font-size: 16px; margin-top: 0px; font-family: 'Lato', sans-serif; margin-left: 40px;">The {{name}} category has been successfully <span *ngIf="is_active">deactivated</span><span *ngIf="!is_active">activated</span>.</p>
    </mat-dialog-content>
</div>

